import type { ReactNode } from 'react';

/**
 * "CORRECTED ON <DAY> AFTER A REFUSAL" — the owner, 23 Oct 2026: "Yes, keep the first", and staff
 * see both.
 *
 * After a refusal because the details on the ID did not match the account, a player may correct the
 * name and the date of birth on their account (sql/1023). The first entry stays on screen as it
 * was given, and this sits under it: the day of the correction, in words, and the value the player
 * corrected it to. One component for the identity case and the player page, so the two say it the
 * same way.
 *
 * `day` arrives written out by the screen that draws it, from a calendar day, never through the
 * browser's clock.
 */
export function correctedOnWords(day: string): string {
  return `Corrected on ${day} after a refusal`;
}

/**
 * Under a correction made AFTER the identity check on screen: that check was sent what is drawn above
 * it, and its findings, CIRA's answer and the date's verdict are about that, not this.
 */
export function madeAfterThisCheckWords(what: 'name' | 'date'): string {
  return `Made after this check, so this check is about the ${what} above`;
}

export function CorrectedAfterRefusal({
  day,
  afterThisCheck,
  children,
}: {
  day: string;
  /** On an identity check this correction came after: what the check is about instead. */
  afterThisCheck?: 'name' | 'date';
  children: ReactNode;
}) {
  return (
    <div style={{ marginTop: 'var(--space-2)' }}>
      {/* The muted text token, as every label beside a value on these screens uses. */}
      <div className="text-muted">{correctedOnWords(day)}</div>
      {children}
      {afterThisCheck !== undefined && (
        <div className="text-muted">{madeAfterThisCheckWords(afterThisCheck)}</div>
      )}
    </div>
  );
}
